<div id="container">
  <div id="warning" #warning *ngIf="showWarning">{{warningText}}</div>
  <div id="player" #player>
    <!-- <img #playButton src="https://img.icons8.com/ios/50/000000/play.png" alt="Start Streaming" (click)="onClickPlayButton()" *ngIf="playButtonVisible"/> -->
    @if(playButtonVisible){
    <div #playButton (click)="onClickPlayButton()">
      <!-- icon play -->
      <app-button-icon [iconName]="'play'"></app-button-icon>
    </div>
    }
    <div *ngIf="showControls" #controls class="controls-container dynamic"
      [class.active]="openChat || openTranslate || openDraw">
      <!-- <button class="control-element" id="balckButton" (click)="startAudio()">AUDIO</button> -->
      <div id="canvascontainer" class="control-element canvas-ctrl" (click)="toggleMic()" [class.mic-off]="!micon"
        [class.disabled]="!isDataChannelReady"
        [attr.title]="(micon ? 'call.mic_on_title' : 'call.mic_off_title') | translate">
        <!-- mic icon: crossed out and red while the microphone is off -->
        <app-button-icon [iconName]="micon ? 'mic' : 'mic-off'"></app-button-icon>
        <canvas #unityCanvas id="unity-canvas" width=160 height=48 tabindex="-1" *ngIf="showUnityCanvas"></canvas>
      </div>
      <!-- <button class="control-element" id="blueButton-" (click)="buttonClicked(ButtonsEnum.FreeHand)">Free Hand</button> -->
      <div class="element-bundle" id="drawContainer" #drawContainer [class.expanded]="openDraw" [class.disabled_]="!isDataChannelReady">
        <div class="drawarea" [class.active]="openDraw">
          <div class="control-element-unstyled" id="blueButton-" (click)="buttonClicked(ButtonsEnum.FreeHand)"
            [class.active]="buttonsActive.freehands" [class.disabled]="!isDataChannelReady">
            <!-- pencil icon -->
            <app-button-icon [iconName]="'freehand'"></app-button-icon>
          </div>
          <!-- <button class="control-element" id="greenButton-" (click)="buttonClicked(ButtonsEnum.Rectangle)">Rectangle</button> -->
          <div class="control-element-unstyled" id="greenButton-" (click)="buttonClicked(ButtonsEnum.Rectangle)"
            [class.active]="buttonsActive.rectangle" [class.disabled]="!isDataChannelReady">
            <!-- rectangle icon -->
            <app-button-icon [iconName]="'rectangle'"></app-button-icon>
          </div>
          <!-- <button class="control-element" id="orangeButton-" (click)="buttonClicked(ButtonsEnum.Circle)">Circle</button> -->
          <div class="control-element-unstyled" id="orangeButton-" (click)="buttonClicked(ButtonsEnum.Circle)"
            [class.active]="buttonsActive.circle" [class.disabled]="!isDataChannelReady">
            <!-- circle icon -->
            <app-button-icon [iconName]="'circle'"></app-button-icon>
          </div>
          <!-- <button class="control-element" id="purpleButton-" (click)="buttonClicked(ButtonsEnum.Arrow)">Arrow</button> -->
          <div class="control-element-unstyled" id="purpleButton-" (click)="buttonClicked(ButtonsEnum.Arrow)"
            [class.active]="buttonsActive.arrow" [class.disabled]="!isDataChannelReady">
            <!-- arrow icon -->
            <app-button-icon [iconName]="'arrow'"></app-button-icon>
          </div>
          <span class="divider"></span>
          <!-- <button id="redButton" (click)="buttonClicked(ButtonsEnum.Pencil)">Pencil</button> -->
          <!-- <button class="control-element" id="clearButton-" (click)="buttonClicked(ButtonsEnum.Clear)">Clear</button> -->
          <div class="control-element-unstyled" id="clearButton-" (click)="buttonClicked(ButtonsEnum.Clear)"
            [class.disabled]="!isDataChannelReady">
            <!-- clear icon -->
            <app-button-icon [iconName]="'erase'"></app-button-icon>
          </div>
          <div class="control-element-unstyled" (click)="colorPicker.click()" [class.disabled]="!isDataChannelReady">
            <!-- color icon -->
            <app-button-icon [iconName]="'colorpicker'" [colorPicker]="colorPicker.value"></app-button-icon>
            <input class="control-element" style="visibility:hidden;" type="color" id="html5colorpicker"
              autocomplete="off" #colorPicker value="#ff0000" (change)="onColorChange()">
          </div>

          <div class="control-element-unstyled" id="thicknessContainer" [class.disabled]="!isDataChannelReady">
            <!-- <label for="thickness">Thickness (between 1 and 10):</label> -->
            <!-- thickness icon-->
            <app-button-icon [iconName]="'fontsize'"></app-button-icon>
            <input type="range" id="thickness" autocomplete="off" #thickness value="3" min="1" max="10"
              (change)="onThicknessChange()">
          </div>

        </div> <!-- chiusura draw area -->

        <!-- pulsanti toggler-->
        <div class="control-element" (click)="toggleDraw()" [class.disabled]="!isDataChannelReady" [class.active]="openDraw"
          [attr.title]="openDraw ? 'Chiudi il disegno' : 'Disegna sul video'">
          @if(!openDraw){
          <app-button-icon [iconName]="'draw'"></app-button-icon>
          }@else{
          <app-button-icon [iconName]="'closedraw'"></app-button-icon>
          }
        </div>
      </div>
      <!-- chiusura container controlli disegno -->
      <!-- <div class="control-element" (click)="colorPicker.click()" [class.disabled]="!isDataChannelReady">
            <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" [style.fill]="colorPicker.value"><path d="m255-917 43-43 347.69 347.69Q669-589 669-555.37q0 33.62-23 56.37L468-321q-23 23-54 23t-54-23L182-499q-23-22.77-23-56.44 0-33.66 23-56.44L371-801 255-917Zm159 159L215-559h398L414-758Zm337.79 477Q722-281 701-302.15T680-353q0-17.35 8-37.17Q696-410 710-431q8-13 19.5-28t22.5-28q11 13 22.5 28t19.5 28q14 21 22 40.83 8 19.82 8 37.17 0 29.7-21.21 50.85-21.21 21.15-51 21.15ZM80 1v-121h800V1H80Z"/></svg>
            <input class="control-element" style="visibility:hidden;" type="color" id="html5colorpicker" autocomplete="off" #colorPicker value="#ff0000" (change)="onColorChange()"> 
          </div> -->
      <span class="divider"></span>
      <div class="control-element" id="clearButton-" (click)="takeScreenshot()" [class.disabled]="!isDataChannelReady"
        title="Fai uno screenshot">
        <app-button-icon [iconName]="'capture'"></app-button-icon>
      </div>
      <div *ngIf="isRecordingVisible" class="control-element" id="clearButton-" (click)="toggleRecording()"
        [class.recording]="isRecording" [class.pill]="isRecording" [class.disabled]="!isRecording &&!isDataChannelReady"
        [attr.title]="isRecording ? 'Registrazione in corso: clic per fermare' : 'Avvia la registrazione'">
        @if(isRecording){
        <span class="pulse-dot"></span>REC {{ recordingTime }}
        }@else{
        <app-button-icon [iconName]="'record'"></app-button-icon>
        }
      </div>
      <span class="divider" *ngIf="canBlur || mustBlur"></span>
      <div class="control-element" id="clearButton-" (click)="toggleBlur()" [class.active]="isBlur" *ngIf="canBlur || mustBlur"
        [attr.title]="isBlur ? 'Sfocatura dei volti attiva: clic per togliere' : 'Sfoca i volti'">
        <app-button-icon [iconName]="isBlur ? 'blur-off' : 'blur-on'"></app-button-icon>
      </div>
      <span class="divider"></span>
      <!-- message: the button opens the message panel over the video (bottom-left) -->
      <div id="textareaContainer" class="element-bundle">
        <div class="control-element" id="chatButton-" (click)="toggleChat()" [class.disabled]="!isDataChannelReady"
          [class.active]="openChat" [attr.title]="(openChat ? 'call.chat_close' : 'call.chat_open') | translate">
          @if(!openChat){
          <app-button-icon [iconName]="'chat'"></app-button-icon>
          }@else{
          <app-button-icon [iconName]="'closedraw'"></app-button-icon>
          }
        </div>
      </div>
      <span class="divider" *ngIf="isTranslateVisible"></span>
      <!-- translate-->
      <div class="element-bundle" *ngIf="isTranslateVisible" id="translateContainer" #translateContainer [class.disabled_]="!isDataChannelReady"
        [class.expanded]="openTranslate">
        <div class="translatearea" [class.active]="openTranslate">
          <!-- not .disabled while the mic is off: the tooltip must still explain why -->
          <div class="control-element pill" id="localTranslation" autocomplete="off" #localTranslation
            (click)="toggleLocalTranslation()" [class.active]="isLocalTranslating" [class.unavailable]="!micon"
            [attr.title]="(!micon ? 'call.translate_own_need_mic' : isLocalTranslating ? 'call.translate_own_active_title' : 'call.translate_own_title') | translate">
            @if(isLocalTranslating){
            <span class="pulse-dot"></span>{{ 'call.translating_own' | translate }}
            }@else{
            <app-button-icon [iconName]="micon ? 'mic' : 'mic-off'" [iconSize]="'20px'"></app-button-icon>{{ 'call.translate_own' | translate }}
            }
          </div>
          <label class="translate-label" for="localLanguageSelect">{{ 'call.i_speak' | translate }}</label>
          <div class="control-element select" id="selectLocalLanguage" autocomplete="off" #selectLocalLanguage>
            <select id="localLanguageSelect" [(ngModel)]="sourceLanguage" (change)="handleSourceLanguageChange()"
              [disabled]="isLocalTranslating || isRemoteTranslating">
              <option *ngFor="let item of languages" [value]="item.value">{{ item.label }}</option>
            </select>
          </div>
          <svg class="translate-swap" width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M7 7h12l-3-3M17 17H5l3 3"></path>
          </svg>
          <label class="translate-label" for="remoteLanguageSelect">{{ 'call.technician_speaks' | translate }}</label>
          <div class="control-element select" id="selectRemoteLanguage" autocomplete="off" #selectRemoteLanguage>
            <select id="remoteLanguageSelect" [(ngModel)]="targetLanguage" (change)="handleTargetLanguageChange()"
              [disabled]="isLocalTranslating || isRemoteTranslating">
              <option *ngFor="let item of languages" [value]="item.value">{{ item.label }}</option>
            </select>
          </div>
          <div class="control-element pill" id="remoteTranslation" autocomplete="off" #remoteTranslation
            (click)="toggleRemoteTranslation()" [class.active]="isRemoteTranslating"
            [attr.title]="(isRemoteTranslating ? 'call.translate_remote_active_title' : 'call.translate_remote_title') | translate">
            @if(isRemoteTranslating){
            <span class="pulse-dot"></span>{{ 'call.translating_remote' | translate }}
            }@else{
            <app-button-icon [iconName]="'voice'" [iconSize]="'20px'"></app-button-icon>{{ 'call.translate_remote' | translate }}
            }
          </div>
        </div>
        <div class="control-element" id="chatButton-" (click)="toggleTranslate()"
          [class.disabled]="!isTranslateEnabled || !isDataChannelReady" [class.active]="openTranslate"
          [attr.title]="(openTranslate ? 'call.translation_close' : 'call.translation') | translate">
          @if(!openTranslate){
          <app-button-icon [iconName]="'language'"></app-button-icon>
          }@else{
          <app-button-icon [iconName]="'closedraw'"></app-button-icon>
          }

        </div>

        <!-- <button id="sendButton" autocomplete="off"  #sendButton (click)="sendTextMessage()">INVIA</button> -->
      </div>

    </div>

    <app-videoplayer #videoplayer [showvideocontrols]="showVideoControls"></app-videoplayer>

    <!-- translation subtitles: a chat in the bottom-right corner, so the video stays visible -->
    <div class="translation-chat" *ngIf="subtitles.length" [class.collapsed]="subtitlesCollapsed">
      @if(subtitlesCollapsed){
      <button type="button" class="translation-chat-reopen" (click)="toggleSubtitles()" [attr.title]="'call.conversation_show' | translate">
        {{ 'call.conversation' | translate }} ({{ subtitles.length }})
      </button>
      }@else{
      <div class="translation-chat-header">
        <span>{{ 'call.conversation' | translate }}</span>
        <button type="button" (click)="toggleSubtitles()" title="Riduci" aria-label="Riduci le traduzioni">&#8211;</button>
      </div>
      <div class="translation-chat-list" #subtitlesList>
        <div class="translation-chat-message" *ngFor="let item of subtitles" [class.local]="item.isLocal">
          <span class="translation-chat-author">{{ (item.isLocal ? 'call.you' : 'call.technician') | translate }}</span>
          <span class="translation-text">{{ item.translation || item.text }}</span>
          <span class="translation-original" *ngIf="item.translation">{{ item.text }}</span>
        </div>
      </div>
      }
    </div>

    <!-- messages typed to the field technician: shown on the headset, kept in the call document -->
    <section class="message-panel" *ngIf="openChat" [attr.aria-label]="'call.chat_title' | translate">
      <div class="message-panel-header">
        <span>{{ 'call.chat_title' | translate }}</span>
        <button type="button" (click)="toggleChat()" [attr.title]="'call.chat_close' | translate"
          [attr.aria-label]="'call.chat_close' | translate">&#215;</button>
      </div>
      <div class="message-panel-list" #chatList>
        @for (message of chatMessages; track message.id) {
        <div class="message-panel-bubble" [class.failed]="!message.sent">
          <span class="message-panel-text">{{ message.text }}</span>
          <span class="message-panel-meta">
            {{ message.time | date:'HH:mm' }} ·
            @if (message.sent) { {{ 'call.chat_sent' | translate }} &#10003; } @else { {{ 'call.chat_not_sent' | translate }} }
          </span>
        </div>
        } @empty {
        <p class="message-panel-empty">{{ 'call.chat_empty' | translate }}</p>
        }
      </div>
      @if (!isDataChannelReady) {
      <p class="message-panel-warning">{{ 'call.chat_waiting' | translate }}</p>
      }
      @if (chatEmojiRemoved) {
      <p class="message-panel-warning">{{ 'call.chat_emoji' | translate }}</p>
      }
      <div class="message-panel-compose">
        <textarea #chatInput rows="1" [(ngModel)]="chatText" (ngModelChange)="handleTextAreaInput()"
          (keydown)="onChatKeydown($event)" [maxlength]="maxTextLength" autocomplete="off"
          [placeholder]="'call.chat_placeholder' | translate" [attr.aria-label]="'call.chat_placeholder' | translate"></textarea>
        <button type="button" class="message-panel-send" (click)="sendTextMessage(); chatInput.focus()"
          [disabled]="!isDataChannelReady || !chatText.trim()" [attr.title]="'call.chat_send' | translate">
          <app-button-icon [iconName]="'sendmessage'" [iconSize]="'18px'"></app-button-icon>
          <span>{{ 'call.chat_send' | translate }}</span>
        </button>
      </div>
      <div class="message-panel-hint">
        <span>{{ 'call.chat_hint' | translate }}</span>
        <span [class.full]="chatText.length >= maxTextLength">{{ chatText.length }}/{{ maxTextLength }}</span>
      </div>
    </section>

    <!-- call diagnostics (Ctrl+Alt+D): what the panel measures of the call, to compare before and after a change -->
    <div class="call-diagnostics" *ngIf="showDiagnostics">
      <div class="call-diagnostics-header">
        <span>{{ 'call.diag.title' | translate }}</span>
        <button type="button" (click)="toggleDiagnostics()" [attr.title]="'call.diag.close' | translate">&#215;</button>
      </div>
      @if(diagnostics?.path || diagnostics?.videoCodec){
      <dl>
        <dt>{{ 'call.diag.link' | translate }}</dt>
        <dd>{{ (diagnostics?.path === 'relay' ? 'call.diag.relay' : 'call.diag.direct') | translate }}
          {{ diagnostics?.protocol }} · RTT {{ diagnostics?.rttMs ?? '-' }} ms</dd>
        <dt>{{ 'call.diag.video' | translate }}</dt>
        <dd>{{ diagnostics?.videoCodec ?? '-' }} · {{ diagnostics?.width ?? '-' }}×{{ diagnostics?.height ?? '-' }}
          · {{ diagnostics?.fps ?? '-' }} fps · {{ diagnostics?.videoKbps ?? '-' }} kbps</dd>
        <dt>{{ 'call.diag.decoder' | translate }}</dt>
        <dd>{{ diagnostics?.decoder ?? '-' }}
          @if(diagnostics?.hardwareDecoder !== null){
          ({{ (diagnostics?.hardwareDecoder ? 'call.diag.hardware' : 'call.diag.software') | translate }})
          }</dd>
        <dt>{{ 'call.diag.lost' | translate }}</dt>
        <dd>video {{ diagnostics?.videoLossPct ?? '-' }}% · audio {{ diagnostics?.audioLossPct ?? '-' }}%</dd>
        <dt>{{ 'call.diag.freezes' | translate }}</dt>
        <dd>{{ diagnostics?.freezes ?? '-' }}</dd>
        <dt>{{ 'call.diag.buffer' | translate }}</dt>
        <dd>video {{ diagnostics?.videoBufferMs ?? '-' }} ms · audio {{ diagnostics?.audioBufferMs ?? '-' }} ms</dd>
        <dt>{{ 'call.diag.delay' | translate }}</dt>
        <dd>{{ diagnostics?.estimatedDelayMs ?? '-' }} ms <small>({{ 'call.diag.delay_note' | translate }})</small></dd>
        <dt>{{ 'call.diag.mic' | translate }}</dt>
        <dd>{{ diagnostics?.micKbps !== null && diagnostics?.micKbps !== undefined ? diagnostics?.micKbps + ' kbps' : ('call.diag.off' | translate) }}</dd>
      </dl>
      }@else{
      <p class="call-diagnostics-waiting">{{ 'call.diag.waiting' | translate }}</p>
      }
      <dl>
        <dt>{{ 'call.diag.sockets' | translate }}</dt>
        <dd>{{ counters.openSockets }} · {{ 'call.diag.peers' | translate }} {{ counters.peers }}</dd>
        <dt>{{ 'call.diag.offers' | translate }}</dt>
        <dd>{{ counters.offersSent }} {{ 'call.diag.sent' | translate }} · {{ counters.offerResends }} {{ 'call.diag.resent' | translate }}
          · {{ counters.offersUnanswered }} {{ 'call.diag.unanswered' | translate }}</dd>
        <dt>{{ 'call.diag.answers' | translate }}</dt>
        <dd>{{ counters.answersSent }}</dd>
        <dt>{{ 'call.diag.reconnections' | translate }}</dt>
        <dd>{{ counters.reconnections }}</dd>
      </dl>
    </div>

    <!-- 
      @if(showVideo){
      <video id="Video" #elementVideo class="video-element" playsInline="true" [src]="videoSrc"></video>
      }
      -->

  </div>
  <div class="box" *ngIf="codecPreferencesShow">
    <span>Codec preferences:</span>
    <select id="codecPreferences" autocomplete="off" disabled #codecPreferences [disabled]="codecPreferencesDisabled"
      (change)="onCodecPreferencesChange($event)">
      <option selected value="">Default</option>
      <option *ngFor="let option of codecPreferencesOptions" [value]="option.value">{{option.text}}</option>
    </select>
  </div>

  <div class="box" *ngIf="lockMouseCheckShow">
    <span>Lock Cursor to Player:</span>
    <input type="checkbox" id="lockMouseCheck" #lockMouseCheck autocomplete="off" />
  </div>

  <div id="message" #message *ngIf="showMessage">{{messageText}}</div>
</div>

<!-- UNITY Audio streaming -->
<!-- <div id="canvascontainer">
    <canvas #unityCanvas id="unity-canvas" width=160 height=48 tabindex="-1" *ngIf="showUnityCanvas"></canvas>
  </div> -->